var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasBodyImage)?_c('ImgPullQuote',{attrs:{"body":_vm.body}}):_c('IconPullQuote',{attrs:{"body":_vm.body}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }